import { createSelector } from '@reduxjs/toolkit';

import { TRootState } from '../index';
import { INotificationsState } from './notifications.slice';

/**
 A selector function to retrieve the notifications data from the store
 @function
 @param {TRootState} state - The root state of the Redux store
 @returns {INotificationsState} The notifications state object from the Redux store
 */
const selectNotificationsState = (state: TRootState): INotificationsState => state.notifications;

/**
 A memoized selector function to retrieve the notifications state from the store
 @function
 @type {import('@reduxjs/toolkit').OutputSelector<RootState, INotificationsState, (res: INotificationsState) => INotificationsState>}
 */
export const getNotificationsState = createSelector(
  [selectNotificationsState],
  (state): INotificationsState => state
);
